"use strict";

jQuery( function ($) {
    // General functionality to show/hide an element after clicking on another element
    //
    // Add the attribute data-toggle-display-target to the element that triggers the show/hide with a selector
    // For example data-toggle-display-target=".coupon-container"
    //
    // Add the attributes data-toggle-display-on and data-toggle-display-off to the target element
    // For example data-toggle-display-on="block" and data-toggle-display-off="none" to show the target element on click
    $( document ).on( 'click', '[data-toggle-display-target]', function ( event ) {
        event.preventDefault();

        var toggle_element      = $( this );
        var target_selector     = toggle_element.data( 'toggle-display-target' );
        var hide_toggle_element = toggle_element.data( 'toggle-display-hideontoggle' );

        if( !target_selector || !$( target_selector ).length ) {
            console.warn( 'Display target not found' );
            return false;
        }

        $( target_selector ).each( function() {
            var display_value_on      = $( this ).data( 'toggle-display-on' );
            var display_value_off     = $( this ).data( 'toggle-display-off' );
            var current_display_value = $( this ).css( "display" );

            if( !display_value_on ) {
                display_value_on = "block";
            }

            if( !display_value_off ) {
                display_value_off = "hidden";
            }

            if( display_value_on !== current_display_value ) {
                $( this ).css( "display", display_value_on );
                $( target_selector ).parent().addClass('open');

                if( hide_toggle_element === true ) {
                    toggle_element.hide();
                }
            } else {
                $( this ).css( "display", display_value_off );
                $( target_selector ).parent().removeClass('open');

                if( hide_toggle_element === true ) {
                    toggle_element.show();
                }
            }
        });

    });
});

